import React from "react";
import { SvgProps } from "react-native-svg";
import images from "./Images";

export interface ImageCardProps extends SvgProps {
  width?: number;
  height?: number;
  aspectRatio?: number;
  name: string;
}

const ImageCard = (props: ImageCardProps) => {
  const { name = "settings", width = 24, height = 24, aspectRatio = 1 } = props;
  const Icon: React.FC<SvgProps> = images[name];
  if (!Icon) {
    return null;
  }
  return <img src={images[name]} style={{ width: width, height: aspectRatio ? width * aspectRatio : height }} />;
};

export const bundleAssets = Array(images);

export default ImageCard;
